import { create } from "zustand";
import { ReportDetailMutations, ReportDetailState } from "./interface";
import { REPORT_DETAIL_INITIAL_STATE } from "./state";
import { createDataActions } from "./actions/dataActions";
import { createUIActions } from "./actions/uiActions";
import { createUpdateActions } from "./actions/updateActions";
import { createAutoSaveActions } from "./actions/autoSaveActions";
import { createDerivedActions } from "./actions/derivedActions";

export const useReportDetailStore = create<ReportDetailState & { actions: ReportDetailMutations }>()(
  (set, get) => {
    const dataActions = createDataActions(set, get, undefined as any);
    const uiActions = createUIActions(set, get, undefined as any);
    const updateActions = createUpdateActions(set, get, undefined as any);
    const autoSaveActions = createAutoSaveActions(set, get, undefined as any);
    const derivedActions = createDerivedActions(set, get, undefined as any);

    // Sobrescreve setReportSections e setDeletedSections para recalcular automaticamente
    const enhancedDataActions = {
      ...dataActions,
      setReportSections: (sections: any) => {
        dataActions.setReportSections(sections);
        derivedActions.recalculateSectionList();
      },
      setDeletedSections: (deletedSections: any) => {
        dataActions.setDeletedSections(deletedSections);
        derivedActions.recalculateSectionList();
      },
      setSelectedCombinedFilter: (filterId: string) => {
        dataActions.setSelectedCombinedFilter(filterId);
        derivedActions.recalculateSectionList();
      },
    };

    return {
      ...REPORT_DETAIL_INITIAL_STATE,
      actions: {
        ...enhancedDataActions,
        ...uiActions,
        ...updateActions,
        ...autoSaveActions,
        ...derivedActions,
        resetReportDetailStore: () => set(() => REPORT_DETAIL_INITIAL_STATE),
        resetRelacoesState: () =>
          set((state) => ({
            ui: {
              ...state.ui,
              activeRelacaoTab: REPORT_DETAIL_INITIAL_STATE.ui.activeRelacaoTab,
              highlightedEntityId: REPORT_DETAIL_INITIAL_STATE.ui.highlightedEntityId,
            },
          })),

        setSummaryData: (summaryData) => {
          const sectionsWithSummary: string[] = [];
          if (summaryData?.topics) {
            const sectionsSet = new Set<string>();
            summaryData.topics.forEach((topic) => {
              if (topic?.related_sections && Array.isArray(topic?.related_sections)) {
                topic.related_sections.forEach((section) => {
                  sectionsSet.add(section);
                });
              }
            });
            sectionsWithSummary.push(...Array.from(sectionsSet));
          }
          set((state) => ({
            data: { ...state.data, summaryData, sectionsWithSummary },
          }));
        },

        setSummaryStatus: (summaryStatus) =>
          set((state) => ({
            data: { ...state.data, summaryStatus },
          })),

        setIsGeneratingSummary: (isGenerating) =>
          set((state) => ({
            ui: { ...state.ui, isGeneratingResume: isGenerating },
          })),
      },
    };
  });